export const globalSearchConstants = {

    GET_GLOBAL_SEARCH_REQUEST:'GET_GLOBAL_SEARCH_REQUEST',
    GET_GLOBAL_SEARCH_SUCCESS:'GET_GLOBAL_SEARCH_SUCCESS',
    GET_GLOBAL_SEARCH_FAILURE:'GET_GLOBAL_SEARCH_FAILURE',

    POST_FEEDBACK_REQUEST:'POST_FEEDBACK_REQUEST',
    POST_FEEDBACK_SUCCESS:'POST_FEEDBACK_SUCCESS',
    POST_FEEDBACK_FAILURE:'POST_FEEDBACK_FAILURE',
}